import { Box, IModal, Modal, ModalContent, ModalOverlay } from '@chakra-ui/core'
import * as React from 'react'
import { IconType } from 'react-icons'
import { H5 } from '../../typography'
import Card from '../Card'
import CardHeader from '../Card/CardHeader'

type ModalWrapProps = IModal & {
  title?: string
  headerIcon?: IconType
}

const ModalWrap: React.FC<ModalWrapProps> = ({
  headerIcon,
  children,
  title,
  onClose,
  isOpen,
  ...rest
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} {...rest} isCentered>
      <ModalOverlay />
      <ModalContent shadow="none" bg="transparent" rounded="md">
        <Card rounded="md" shadow="md" m={4} overflow="auto" justifyContent="flex-start">
          {title && (
            <CardHeader alignItems="center" flexDirection="row">
              {headerIcon && <Box mr={3} as={headerIcon} />}
              <H5 mb={0}>{title}</H5>
            </CardHeader>
          )}
          {children}
        </Card>
      </ModalContent>
    </Modal>
  )
}

export default ModalWrap

ModalWrap.defaultProps = {
  title: '',
  size: 'xl',
  scrollBehavior: 'inside',
  isCentered: true,
  preserveScrollBarGap: true
}
